<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Reporting",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Reporting",
      items: [
        {
          text: "Home",
        },
         {
          text: "Traffic Records",
        },
        {
          text: "Reporting",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>